import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import VistaPanoramica from './pages/VistaPanoramica';
import Desempeno from './pages/Desempeno';
import AreasMejora from './pages/AreasMejora';
import Intereses from './pages/Intereses';
import Estudiantes from './pages/Estudiantes';
import QuestionBank from './pages/QuestionBank';
import Configuracion from './pages/Configuracion';
import Ayuda from './pages/Ayuda';
import Usuarios from './pages/Usuarios';
import Empresas from './pages/Empresas';
import Login from './pages/Login';
import Register from './pages/Register';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/vista-panoramica" />} />
                    <Route path="/vista-panoramica" element={<VistaPanoramica />} />
                    <Route path="/desempeno" element={<Desempeno />} />
                    <Route path="/areas-mejora" element={<AreasMejora />} />
                    <Route path="/intereses" element={<Intereses />} />
                    <Route path="/estudiantes" element={<Estudiantes />} />
                    <Route path="/question-bank" element={<QuestionBank />} />
                    <Route path="/configuracion" element={<Configuracion />} />
                    <Route path="/ayuda" element={<Ayuda />} />
                    <Route path="/usuarios" element={<Usuarios />} />
                    <Route path="/empresas" element={<Empresas />} />
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 